import { render, staticRenderFns } from "./TbilisiMallMap.vue?vue&type=template&id=8edf6a90&scoped=true"
import script from "./TbilisiMallMap.vue?vue&type=script&lang=js"
export * from "./TbilisiMallMap.vue?vue&type=script&lang=js"
import style0 from "./TbilisiMallMap.vue?vue&type=style&index=0&id=8edf6a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edf6a90",
  null
  
)

export default component.exports